<template>
    <Container>
        <SectionWrapper>
            <SettingButton
                v-for="(button, index) in settingsButtons"
                :key="`s-${index}`"
                :href="button.to"
                :icon="button.icon"
                target="_blank">
                {{ button.text }}
            </SettingButton>
        </SectionWrapper>
    </Container>
</template>

<script setup lang="ts">
    import LogoIcon from '@/components/icons/Logo.vue';
    import MegaphoneIcon from '@/components/icons/Megaphone.vue';
    import NotesIcon from '@/components/icons/Notes.vue';
    import PhoneIcon from '@/components/icons/Phone.vue';
    import OpenBookIcon from '@/components/icons/OpenBook.vue';
    import SheetIcon from '@/components/icons/Sheet.vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const settingsButtons = computed(() => [
        {
            icon: LogoIcon,
            text: t('About.theCompany'),
            to: 'https://24horas.pt/o-24horas/',
        },
        // {
        //     icon: OpenBookIcon,
        //     text: t('About.provider'),
        //     to: 'https://24horas.pt/',
        // },
        // {
        //     icon: SheetIcon,
        //     text: t('About.technicalSheet'),
        //     to: 'https://24horas.pt/',
        // },
        // {
        //     icon: PhoneIcon,
        //     text: t('About.contacts'),
        //     to: 'https://24horas.pt/',
        // },
        // {
        //     icon: NotesIcon,
        //     text: t('About.status'),
        //     to: 'https://24horas.pt/',
        // },
        // {
        //     icon: MegaphoneIcon,
        //     text: t('About.howToPublish'),
        //     to: 'https://24horas.pt/',
        // },
    ]);
</script>

<style scoped></style>
